<template>
  <div class="tab-view">
    <div class="tab-bar">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-btn"
        :class="{ active: current === tab.id }"
        @click="current = tab.id"
      >
        {{ tab.label }}
      </button>
    </div>
    <template v-for="tab in tabs" :key="tab.id">
      <div v-show="current === tab.id">
        <slot :name="tab.id" />
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  tabs: {
    type: Array,
    required: true
  },
  activeTab: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:activeTab'])

const internal = ref(props.activeTab ?? props.tabs[0]?.id)

watch(
  () => props.activeTab,
  (value) => {
    if (value != null) internal.value = value
  }
)

const current = computed({
  get: () => internal.value,
  set: (value) => {
    internal.value = value
    emit('update:activeTab', value)
  }
})
</script>

<style scoped>
.tab-view {
  display: flex;
  flex-direction: column;
}

.tab-bar {
  display: flex;
  gap: 0.25rem;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
}

.tab-btn {
  padding: 0.6rem 1.25rem;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  margin-bottom: -1px;
}

.tab-btn:hover {
  color: #334155;
}

.tab-btn.active {
  color: var(--highlights);
  border-bottom-color: var(--highlights);
}
</style>
